export default [
  {
    path: '/admin/corporate/company-profiles',
    name: 'company-profile',
    meta: { requiresAuth: true },
    component: () => import('@/pages/corporate/company/index.vue')
  }
]
